import script from "./RatingSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingSlider.vue?vue&type=script&setup=true&lang=ts"

import "./RatingSlider.vue?vue&type=style&index=0&id=649179b5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649179b5"]])

export default __exports__